export default "__VITE_ASSET__H79zyJ19__"